import { createSelector } from 'reselect';
import { handleRemoveAction, handleSubmitAction } from '../../../core/store/helpers/reducer-helper';
import * as actions from './sync-up-item.actions';
import { SyncUpItem } from './sync-up-item.model';

export interface State {
    ids: Array<string>;
    entities: { [id: string]: SyncUpItem };
    syncCount: number;
}

export const initialState: State = {
    ids: [],
    entities: {},
    syncCount: 0
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: actions.Actions): State {
    switch (action.type) {
        case actions.CREATE: {
            return handleSubmitAction(state, action);
        }
        case actions.UPDATE: {
            return handleSubmitAction(state, action);
        }
        case actions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        case actions.SET_SYNC_COUNT: {
            return  {
                ...state,
                syncCount: state.ids.length
            };
        }
        case actions.UPDATE_FROM_OPERATION_RESULT: {

            const result = action.payload;
            const key = action.payload.item.key;
            const response = result.response;

            const syncUpItem = state.entities[key];

            if (!syncUpItem) {
                return state;
            }

            return {
                ...state,
                ids: state.ids,
                entities: {
                    ...state.entities,
                    [key]: new SyncUpItem({
                        ...syncUpItem,
                        response
                    })
                }
            };
        }
        default: {
            return state;
        }
    }
}

export const getEntities = (state: State) => state.entities;

export const getIds = (state: State) => state.ids;

export const getAll = createSelector(getEntities, getIds, (entities, ids) => ids.map(id => entities[id]));



// WEBPACK FOOTER //
// ./src/vas/business-objects/sync-up-item/sync-up-item.reducer.ts